package fyi.moko.hotpl.domain.photo

/**
 * 사진 바이트에서 온디바이스 신호를 뽑는다. 규칙은 [PhotoSignalMapper]가 공통으로 갖고,
 * 여기는 플랫폼 API만 감싼다.
 *
 * 신호를 못 뽑으면 null이 아니라 **빈 [PhotoSignals]** 를 돌려준다 — 그래야 매퍼가
 * [PhotoKindGuess.UNKNOWN]으로 떨어뜨리고, 사진은 "아직 분류 안 됨"으로 남는다. 분류에
 * 실패했다고 사진 추가 자체가 실패하면 안 된다.
 */
interface PhotoSignalExtractor {
    suspend fun extract(imageBytes: ByteArray): PhotoSignals
}

/**
 * 아직 신호를 못 뽑는 플랫폼용. 모든 사진이 분류되지 않은 채로 들어가고, 사용자가 화면에서
 * 직접 정한다 — 기능이 없는 것이지 깨진 것이 아니다.
 */
object NoPhotoSignals : PhotoSignalExtractor {
    override suspend fun extract(imageBytes: ByteArray): PhotoSignals =
        PhotoSignals(labels = emptyList(), textBlocks = 0)
}

/** 신호를 뽑아 종류까지 정한다. 화면과 저장 층이 쓰는 진입점. */
class PhotoClassifier(private val extractor: PhotoSignalExtractor) {
    suspend fun classify(imageBytes: ByteArray): PhotoKindGuess =
        runCatching { PhotoSignalMapper.map(extractor.extract(imageBytes)) }
            .getOrElse { PhotoKindGuess.UNKNOWN }
}
